import type { CreationDialogAction } from 'client/js/main/actions/LinkManager/CreationDialogActions';
import {
  DISMISS_LINK_CREATION_DIALOG,
  UPDATE_BULK_CREATION_DIALOG_OPEN_STATE,
  UPDATE_SINGLE_CREATION_DIALOG_OPEN_STATE,
} from 'client/js/main/actions/LinkManager/CreationDialogActions';
import { ReduxAsyncActionsService } from 'client/js/redux/services/ReduxAsyncActions.service';
import type { WrappedReducer } from 'client/js/redux/types/ReduxAsyncActions.types';
import { deepCopy } from '../../../../../shared/utils';
import type { CreationDialogReducerType } from './Types/CreationDialogReducerType';

export const INIT_STATE: WrappedReducer<CreationDialogReducerType> = {
  bulkOpen: false,
  singleOpen: false,
  loadingStatus: 0,
  loading: false,
  error: null,
};

const handler = (state: WrappedReducer<CreationDialogReducerType>, action: CreationDialogAction) => {
  switch (action.type) {
    case UPDATE_SINGLE_CREATION_DIALOG_OPEN_STATE:
      return {
        ...state,
        singleOpen: action.data?.open,
      };
    case UPDATE_BULK_CREATION_DIALOG_OPEN_STATE:
      return {
        ...state,
        bulkOpen: action.data?.open,
      };
    case DISMISS_LINK_CREATION_DIALOG:
      return {
        ...state,
        bulkOpen: false,
        singleOpen: false,
      };
    default:
      return state;
  }
};

const CreationDialogReducer = ReduxAsyncActionsService.wrapReducer(deepCopy(INIT_STATE), handler, {});

export default CreationDialogReducer;
